<h1 mat-dialog-title>{{ 'offer.catalog.request.view.value' | translate }}</h1>
<mat-dialog-content>
    <app-core-offer-catalog-request-view [id]="id"></app-core-offer-catalog-request-view>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row x_center">
        <button class="btn_cta btn_little" (click)="close()">{{ 'action.back' | translate }}</button>
    </div>
</mat-dialog-actions>
